import { render, staticRenderFns } from "./SchemaJumpConfig.vue?vue&type=template&id=4c2f892e"
import script from "./SchemaJumpConfig.vue?vue&type=script&lang=js"
export * from "./SchemaJumpConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports